<template>
  <div
    class="inline-flex items-center w-full px-4 py-3"
    style="min-height: 30px;"
  >
    <!-- <img src="/images/map.svg" style="height: auto; width: 18px;" /> -->
    <img
      :src="image"
      style="height: auto; width: 18px;"
      :style="isInDarkMode ? 'filter: invert(100%)' : ''"
    />
    <div
      class="w-full text-m text-left text-slate-900 dark:text-white ml-2 capitalize"
    >
      {{ name }}
    </div>
    <div class="mr-2 text-xl text-gray-600 dark:text-slate-50">
      <svg
        height="15px"
        width="15px"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        data-name="Layer 1"
        viewBox="0 0 100 100"
        x="0px"
        y="0px"
      >
        <path
          d="M36.66,12.71a5,5,0,0,0-7.07,7.07L59.8,50,29.59,80.22a5,5,0,1,0,7.07,7.07L70.41,53.54a5,5,0,0,0,0-7.07Z"
        ></path>
      </svg>
    </div>
  </div>
</template>

<script>
import maki from "maki";

String.prototype.trunc = function(n) {
  return this.substr(0, n - 1) + (this.length > n ? ".." : "");
};

export default {
  name: "Location",
  components: {},
  props: {
    name: String,
    type: String
  },
  data() {
    return {
      image: null,
      isInDarkMode: false
    };
  },
  mounted() {
    const icon = this.type
      ? this.type
          .split(",")
          .map(i => i.trim())
          .find(i => maki.layouts.all.all.includes(i))
      : null;

    this.image = icon ? `/maki/${icon}-11.svg` : "/images/map.svg";

    const darkModePreference = window.matchMedia(
      "(prefers-color-scheme: dark)"
    );

    this.isInDarkMode = darkModePreference.matches;
    darkModePreference.addEventListener(
      "change",
      e => (this.isInDarkMode = e.matches)
    );
  }
};
</script>
